import React from 'react';
import { useSelector } from 'react-redux';

import { useSiteCapabilityCheck } from '../../../common/hooks/use-site-capability-check';
import { selectSite } from '../../site/siteSlice';
import { ActivityView } from '../common/ActivityView';
import { useDateRangeOptions } from '../common/use-date-range-options';

export function SenseOnlyActivity() {
  const { is_consumption_site: isConsumptionSite } = useSelector(selectSite);
  const { siteHasBattery } = useSiteCapabilityCheck();
  const DATE_RANGE_OPTIONS = useDateRangeOptions();

  return (
    <ActivityView
      options={{
        dateRange: DATE_RANGE_OPTIONS,
        powerSources: { solar: !isConsumptionSite, grid: true, battery: siteHasBattery },
      }}
    />
  );
}
